export default __webpack_public_path__ + "static/media/vect-eclipse-primary.f85f65d2.svg";